import React from 'react';
import HeroSection from '../components/hero-section/HeroSection';
import Programs from '../components/programs/Programs';
import WhoWeAre from '../components/who-we-are/WhoWeAre';
import TrainingApproach from '../components/training-approach/TrainingApproach';
import Services from '../components/services/Services';
import WhyChooseUs from '../components/why-choose-us/WhyChooseUs';
import Trainers from '../components/trainers/Trainers';
import BmiCalculator from '../components/bmi-calculator/BmiCalculator';
import CallToAction from '../components/cta/CallToAction';
import { branchesData } from '../data/branchesData';
import { FaMapMarkerAlt, FaDirections, FaInstagram } from 'react-icons/fa';
import { motion } from 'framer-motion';

const Home = () => {
  const transition = { type: 'spring', duration: 2.5 };

  return (
    <div className="flex flex-col gap-12 w-full overflow-x-hidden">
      <HeroSection />

      {/* ── 3 BRANCHES SHOWCASE BANNER ON HOME ── */}
      <section className="px-4 md:px-12 py-6 max-w-7xl mx-auto w-full">
        <motion.div
          className="bg-gradient-to-r from-red-600/15 via-[#181a20] to-red-600/15 p-6 md:p-10 rounded-3xl border border-red-600/30 backdrop-blur-xl shadow-2xl relative overflow-hidden"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={transition}
          viewport={{ once: true }}
        >
          {/* Top subtle line */}
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-red-600 to-transparent" />

          <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8">
            <div>
              <span className="inline-block bg-red-600/20 text-red-500 border border-red-500/30 text-[10px] font-black uppercase tracking-widest px-3.5 py-1 rounded-full mb-2">
                Convenient Locations
              </span>
              <h2 className="text-2xl sm:text-4xl font-black uppercase text-white">
                Our 3 Gym Units in Coimbatore
              </h2>
            </div>
            <p className="text-gray-300 text-xs sm:text-sm max-w-md">
              Train near your home or workplace. Get access to all 3 units under our universal membership plan.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {branchesData.map((branch, i) => (
              <motion.div
                key={branch.id}
                className="bg-gradient-to-b from-[#181a24]/90 to-[#12141c]/90 hover:bg-white/10 p-6 rounded-3xl border border-white/10 hover:border-red-500/50 transition-all duration-300 flex flex-col justify-between group shadow-xl"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ ...transition, delay: i * 0.1 }}
                viewport={{ once: true }}
                whileHover={{ y: -6 }}
              >
                <div>
                  <div className="flex items-center justify-between mb-3">
                    <span className="bg-red-600 text-white text-[11px] font-black uppercase px-3 py-0.5 rounded-full shadow-md">
                      {branch.unitNumber}
                    </span>
                    <span className="text-[10px] text-red-400 font-bold uppercase">
                      {branch.badge}
                    </span>
                  </div>
                  <h3 className="text-lg font-bold text-white group-hover:text-red-400 transition-colors mb-2">
                    {branch.name}
                  </h3>
                  <p className="text-xs text-gray-300 leading-relaxed mb-4 flex items-start gap-1.5">
                    <FaMapMarkerAlt className="text-red-500 text-sm flex-shrink-0 mt-0.5" />
                    <span>{branch.address}</span>
                  </p>
                </div>

                <div className="flex flex-col gap-2 pt-4 border-t border-white/10">
                  <a
                    href={branch.mapsUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="bg-red-600 hover:bg-red-500 text-white font-bold py-2.5 px-3 rounded-xl text-xs uppercase tracking-wider flex items-center justify-center gap-2 transition-all shadow-md"
                  >
                    <FaDirections /> Open Google Maps
                  </a>
                  <a
                    href={branch.instagram}
                    target="_blank"
                    rel="noreferrer"
                    className="bg-white/5 hover:bg-white/15 text-gray-200 hover:text-white py-2 px-3 rounded-xl text-xs flex items-center justify-center gap-2 transition-all"
                  >
                    <FaInstagram className="text-red-500" /> {branch.instaHandle}
                  </a>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </section>

      <Programs />
      <WhoWeAre />
      <TrainingApproach />
      <Services />
      <WhyChooseUs />
      <Trainers />
      <BmiCalculator />
      <CallToAction />
    </div>
  );
};

export default Home;

